module.exports = __webpack_public_path__ + "img/imgcamcelbt.5e4702a9.png";